import { type ReactNode } from 'react'

export interface DocumentsQuestionAnswerEditorProps {
  documentRequests: ReactNode
}

export function DocumentsQuestionAnswerEditor({
  documentRequests,
}: DocumentsQuestionAnswerEditorProps) {
  return <div>{documentRequests}</div>
}
